const openClearCacheReducers = (state = false, action) => {
  switch (action.type) {
    case "openCache":
      return (state = true);
    case "closeCache":
      return (state = false);
    default:
      return state;
  }
};
export default openClearCacheReducers;
